import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiPlus, mdiSwapVertical } from "@mdi/js";
import { Button, Chip } from "@heroui/react";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";
import SortableSettingsList from "./SortableSettingsList";

const FaqTab: React.FC = observer(() => {
  const {
    displayFaqs,
    faqs,
    isLoading,
    faqOrderMode,
    isFaqOrderDirty,
    isFaqsOrderSaving,
  } = feedbackSettingsStore;

  if (isLoading) {
    return <div className="fbs-tab__loading">Загрузка...</div>;
  }

  return (
    <div className="fbs-tab">
      <div className="fbs-tab__header">
        <div>
          <h2 className="fbs-tab__title">Частые вопросы (FAQ)</h2>
          <p className="fbs-tab__desc">
            {faqOrderMode
              ? "Перетащите пункты за ручку слева, чтобы изменить порядок. Нажмите «Сохранить», чтобы применить изменения."
              : "Управление вопросами и ответами в блоке FAQ."}
          </p>
        </div>
        <div className="fbs-tab__actions">
          {faqOrderMode ? (
            <>
              <Button
                variant="ghost"
                onPress={() => feedbackSettingsStore.cancelFaqOrderMode()}
                isDisabled={isFaqsOrderSaving}
              >
                Отмена
              </Button>
              {isFaqOrderDirty && (
                <Button
                  variant="primary"
                  onPress={() => void feedbackSettingsStore.saveFaqOrder()}
                  isPending={isFaqsOrderSaving}
                >
                  Сохранить
                </Button>
              )}
            </>
          ) : (
            <>
              {faqs.length >= 2 && (
                <Button
                  variant="ghost"
                  onPress={() => feedbackSettingsStore.enterFaqOrderMode()}
                >
                  <Icon path={mdiSwapVertical} size={0.8} />
                  Изменить порядок
                </Button>
              )}
              <Button
                variant="primary"
                onPress={() => feedbackSettingsStore.openFaqCreate()}
              >
                <Icon path={mdiPlus} size={0.8} />
                Добавить вопрос
              </Button>
            </>
          )}
        </div>
      </div>

      {faqs.length === 0 ? (
        <div className="fbs-tab__empty">Нет вопросов. Добавьте первый.</div>
      ) : (
        <SortableSettingsList
          items={displayFaqs}
          orderEditMode={faqOrderMode}
          isSaving={isFaqsOrderSaving}
          onReorder={(from, to) => feedbackSettingsStore.moveFaqDraft(from, to)}
          onEdit={(faq) => feedbackSettingsStore.openFaqEdit(faq)}
          renderContent={(faq) => (
            <>
              <div className="fbs-list__title-row">
                <span className="fbs-list__title">{faq.question}</span>
                <Chip
                  size="sm"
                  color={faq.is_active ? "success" : "default"}
                  variant="soft"
                >
                  {faq.is_active ? "Видим" : "Скрыт"}
                </Chip>
              </div>
              <p className="fbs-list__subtitle">{faq.answer}</p>
            </>
          )}
        />
      )}
    </div>
  );
});

FaqTab.displayName = "FaqTab";
export default FaqTab;
